import { queryClient } from '../queryClient';

import { createLogoQueryOptions } from './queryOptions';

export async function prefetchLogoQuery({ collectionId }: { collectionId: number }) {
  return queryClient.prefetchQuery(createLogoQueryOptions({ collectionId }));
}
